import { useEffect, useState } from "react";

// True below the given breakpoint (default: phones / small tablets).
export function useIsMobile(bp = 768) {
  const q = `(max-width: ${bp - 1}px)`;
  const [m, setM] = useState(() => typeof window !== "undefined" && window.matchMedia(q).matches);
  useEffect(() => {
    const mq = window.matchMedia(q);
    const on = () => setM(mq.matches);
    mq.addEventListener("change", on);
    return () => mq.removeEventListener("change", on);
  }, [q]);
  return m;
}
